<template>
    <div id="login" class="ui container">
        <div class="mobile hidden">
            <h1 class="ui center aligned header">
                <!-- 管理後台登入 -->
                {{ $t('ui.pages.login.provider_management_login') }}
            </h1>
            <div class="ui divider"></div>
            <h4 class="ui center aligned header" v-if="is_development">
                {{ current_node_identity }}
            </h4>
        </div>
        <div class="ui middle aligned center aligned doubling two column grid">
            <div class="column">
                <h2 class="ui teal header">
                    <div class="content">
                        <img class="ui image" src="/images/lms_logo.png">
                    </div>
                </h2>
            </div>

            <div class="column">
                <h1 class="ui center aligned header mobile only">
                    <!-- 管理後台登入 -->
                    {{ $t('ui.pages.login.provider_management_login') }}
                </h1>
                <h3 class="noty">
                    <!-- 請輸入您的帳號及密碼 -->
                    {{ $t('ui.pages.login.please_enter_your_account_and_password') }}

                    <!-- 2018-06-28 解禁 -->
                    <div class="ui dropdown item" v-dropdown
                        style="position: absolute; right: 0;">
                        {{ $t('ui.links.top_menu.language') }}
                        <i class="dropdown icon"></i>
                        <div class="menu">
                            <a class="item" @click="change_i18n('zh-TW')">繁體</a>
                            <a class="item" @click="change_i18n('zh-CN')">简体</a>
                            <a class="item" @click="change_i18n('ja-JP')">日本語</a>
                            <a class="item" @click="change_i18n('ko-KR')">한국어</a>
                            <a class="item" @click="change_i18n('en-US')">English</a>
                            <a class="item" @click="change_i18n('de-DE')">Deutsch</a>
                            <a class="item" @click="change_i18n('es-ES')">Español</a>
                            <a class="item" @click="change_i18n('vi-VN')">Tiếng Việt</a>
                            <a class="item" @click="change_i18n('km-KH')">ភាសាខ្មែរ</a>
                        </div>
                    </div>
                </h3>

                <NotificationBox :notification="notification"/>
                <ErrorBox :errors="errors"/>

                <div class="ui large form" v-on:submit.prevent>
                    <div class="ui stacked segment">
                        <div class="field">
                            <div class="ui left icon input">
                                <i class="user icon"></i>
                                <input type="text" name="username"
                                    :placeholder="$t('ui.pages.login.account')" v-model="username" @keyup.enter="focus_input('password')" required>
                            </div>
                        </div>
                        <div class="field">
                            <div class="ui left icon input">
                                <i class="lock icon"></i>
                                <input type="password" name="password"
                                    :placeholder="$t('ui.pages.login.password')" v-model="password" @keyup.enter="focus_input('captcha')" ref="password" required>
                            </div>
                        </div>
                        <div class="field" v-if="need_captcha">
                            <img class="captcha" v-if="captcha_image_base64" :src="'data:image/jpg;base64,' + captcha_image_base64" alt="captcha" @click="render_captcha">
                            <input type="text"
                                :placeholder="$t('ui.pages.login.verification_code')" v-model="captcha_user_answer" @keyup.enter="submit()" ref="captcha" required>
                        </div>

                        <div class="ui divider"></div>
                        <button class="ui large basic red button" style="width: 48%;" @click="auto_input" v-if="is_development">
                            <!-- 自動輸入測試帳號 -->
                            {{ $t('ui.pages.login.btns.auto_input_test_account') }}
                        </button>
                        <button type="submit" class="ui large teal submit button" :class="{'loading': is_logging}" style="width: 48%;" @click="submit()">
                            <!-- 登入 -->
                            {{ $t('ui.pages.login.btns.login') }}
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ErrorBox from './components/errors.vue'
import NotificationBox from './components/notification.vue'

export default {
    props: {
    },
    data() {
        return {
            is_development: (ENV.NODE_ENV == 'development') ? true : false,
            is_initialized: false,
            password: null,
            is_processing: false,
            username: null,
            encrypted_answer: null,
            captcha_user_answer: null,
            captcha_image_base64: null,
            notification: {},
            errors: [],
            need_captcha: localStorage.getItem("need_captcha") == "true" ? true : false,
            electron_cache_identity: localStorage.getItem("electron_cache_identity"),
            is_logging: false,
        }
    },
    computed: {
        node_index() {
            return parseInt(new RestUrl(location.href).get_query_string("node_index") || 0)
        },
        current_node_identity() {
            return this.node_index > 0 ? ENV.VUE_APP_SECOND_NODE_IDENTITY:ENV.VUE_APP_FIRST_NODE_IDENTITY
        },
        login_url() {
            if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                // 使用 environment variables 內的 LICENSE_KEY 為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': window.LICENSE_KEY || this.electron_cache_identity
                    },
                    "?captcha=" + this.need_captcha
                )
            } else if (ENV.NODE_ENV == 'development') {
                // 使用 env.js 內的 LICENSE_KEY 為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': this.current_node_identity
                    },
                    "?captcha=" + this.need_captcha
                )
            } else {
                // 使用HOSTNAME為尋找Node的依據
                return new RestUrl(this.$store.state.settings.login_url).parse(
                    {
                        'node_identity': ""
                    },
                    "?captcha=" + this.need_captcha
                )
            }
        },
        captcha_url() {
            return this.$store.state.settings.captcha_url
        },
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        async init() {
            try {
                if (this.need_captcha) {
                    this.captcha_image_base64 = "iVBORw0KGgoAAAANSUhEUgAAATYAAABQCAYAAACTZllaAAAXyklEQVR4Xu2db2wU6X3HvzM7axjDGq99NbnYjqlDXVAKGDbh4ia9I8YoL0LbUypTNa0CTSUD6ZsLamVLlxenKifhtLrjTXKcX1Tm1KtUrCaXyjn1gqHQRPGFnMEcTTg5Ph8ONglw9hL/W5ud3emLmd/Ds7Oz86z/suz9PhLCO/PMv2ee5/v8/jwzowGw4RIOh6FpGnRdx/z8PEzTxPz8PAKxsSw0LRy8PnAtkEZSUYJhmGLFtm3ouo5IJALLsjA7O4uSkhJoAOxIJIJUKoWFhQWkUikYhgHLslT7BABoSulREVIVCMRGfufJMEzxsWHDBszOzmYtNzRNQzqdxtzcnFioaRqqqqpg2zbu3buXtdFiUBt0wSWWL5wMwxQriUQCuq5D13WUlpYCAKamphyLjQpVVFRgdnYWCwsLQfvyECw8KlmyoQeuV2+fUpRgGKaYKSkpgWEYmcbZxo0b7UQikeGCVlVVYWZmBpZl4cGDB4E7VaHpwdJkp9XStbz1DMMUK0888QQ+/PBD8ds0TSQSCRgzMzMAgFAoBMuysHnzZvT396O2thaGYSCdTgfsVm1S6VqwRaaSpXRK4apqqj0wDFOsjI2NYf/+/bh9+zbm5uagaRpCoZDjioZCIZimiZmZGRiGgWQyiWTSyTYahgFNU1lVDMMwjwZZn0zTxMLCAnTTNJFKpUCWG2VD5+bmxPQPhmGYQiYajQJuMiEcDkPTdd1Op9PQNA2UIbVtG/IyhmGYQkXTNBiGgVQqJea1BQfAGIZhHkNY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKTpY2BiGKToMVYHlcj9hofvnv0H35du4dntGVZxZQ3Z9fCOO7P04jnzmSZSbq94UGGbNWNUXTQ6OT+PZf30Xo3HFR5eZR0pddD3e+NpONFZHVEUZpuBY0xdNDo5PY993rrCoPQaMxuex7ztXMDg+rSrKMI8FqyJs9xMWnv3Xd/G7ef5K++PC7+ade3Y/wfeMefxZFWHr/vlvHqml1tJQgZaGCtRXmqqiOaF9RNc49hSriaC9uQ5wz6G9uQ7nju1GrMZxE5dzTSpG4/Po/vlvVMUYpuBZlV7bffm2qoiS9uY6nDy4VVUMABBPWKh4/pL4fe7YbgBAR+8wOi+MBmzp0NJQIYSDoGN39Y9jZCIhlscTFgZuTeGdE3uz9gMAn37pMgbGcrt0LQ0V4m9ZrOorzYx1fUOTiNVExHlES8OImgbOHt4BADh05nrGea0U3Zdv47mna1XFGKagWRVhW+vs53KtKllAvLQ1VWf87hua9C1HREvDgevbm+syBCwXrY2bEZ9LZiw7eXCrEMN3TuzF0bM30HPtbo49LI21vncMsxosTxHWiI7eYUCyovqGJtE3NCncxeUyMDYtjkEEWWyykJKlOPniM2IZWYwHTl/FYugbmsTA2DRGJhLoG5pE666qjPVd/eOI1ZYhVhMR1lu+VinDfJR4LITNG1caGJtG+/4tSlfs5MGtWZbYgdNXs6yuvqFJIUZevBbboTPXxbKBsWnEPcH2WE0kUGx7rt1F39AkRiYSiCesDCvMK4SySxuriaDzwigOvHIFJw9uFedQX2kiahpZ58EwH2UeC2GLloYzrJfWXVWImsayXVA/yELzWmz0u62pWghRz+CdrO1VccGu/vGM3153U0U8YeFoz3sYGJtGW1M1OnqHC1bUyAKl+vKLPY5MJMQANXBrCmcP71Ba4V3944gnrKxBZGBsWtRnPGGJfUdNI+O+UJw0CIp7LhbZqlaFLeC2bW98V64TL/L1xhMWDp25rgxvePcnH9Nr7cdqIqivNNHVP56zLcv1LLarLXMGa0V79rve1WDllWEV6Bm8g/pKM6ODjEwkHMvNzSD6QS6rjMrK81po3t9d/eOIlobRNzSZ0Sg6L4yivblO2Wm8DVCOyXnXyQ3Am1wYmUigo3cYsdqyh9f4b0eBhRngs18FPvVFLJXu7m688MILKC8vx+DgoKp4TvxcfBW57g+JGaTBpqWhQohlS0MFPv3SZd9tAaB9/xYxEA7cmlKGCU4e3JpTmNqaqrPCBHCv92jPe4AbmlAdg7Bf2p/xu+fa3Zz1RmVHJhI4dOY6BsamhceRS9y8+2tpqMhIsMlETQP1lSYGxqYRLQ379q+O3uGsujl3bDc6L4wqxVw+9mryWAhbfaWJnsE7oqNHTUPE2ILwik8+qCy2eMJCR+8wzh3b7XvTo6YR2KGDbmrQuram6iyRJbQT550/1m0A7r0P/Oifgbdf8xe4qd8CU3eAss1A2ccy1/3iLeDt1/C3U44lumXLFiwHv84PT8xU3FPFSE4uvIw8cMl1R+0iahqI1ZYt2bIP6qTeayPrCe51ycfMdV9Vwkf3m6ynWE0E8YSFrv5xdJ6/iXjCQltTNbr6x3Hg9FW0NVWjvbkuy9L0Jsfo3EYmEuLcSJTiCUt4AzQAnD28I+N6WndVCSuwrak6y7qlZfIAJN+TtWBtjrJMvCbxSiUN/FBZbPnQ1lQtGt6a0vqSECdM3XkocH/2T0DZZlT1/SPuDv3qYfmanc66e+8Db33b2QZAXV0dXnjhBRw5ciT3sRT4xTK9BFlzXiumpaEC8bkkRiYSaN/vCO7ArSnRCalj5WMRtDRU4OTBrejoHcbJg1vFANU3NIkDp6+K+YNeoe25dhdd/eO+Md+jZ2+Iju4d8BY7uBJy/fUM3nFc+1tTol2R5VhfaaKjdxhd/ePo6h9H664qMS0Ikmh59903NInWxs2orzTRNzSJqGmgpaEiIw5MiSoZCoEAwKut2+Bl4NZUhltKyTAEDHYrTcEKWzxhZd0MErOgGMRSaGmoyDsrStYiZUf7hiZx6Mz1jIB+kKh5jyN3Sr+Orlqfxae+6PyTBe7Kf6Im/FuMDf0KZZEwdm4vx7s37mNq7F3g4ncd95WsuM9+FTff+rbqKGtOe3OdqFfqzEd73hMxtKXEw+DpdHIMcGQiIcIO1HmpXJawSQJ78uDWjLjiShKriSA+l0SstgwDt6aEkBHtzXXouXY3r0GfrCzaPmoaOHd8D+orTRHmAYBzx/dkbTviJr5yXaM3lir313zObSUoWGHzCgqkSukbmsyYvzVwa0o0dr/yMn6jp8oF9KKdOI+O3mG82roNLQ0VeP+bnxOjWlf/eOAI7V3XIj0h4bddrLYsa/3Jg1vRM3gnswEtzDhW14I0D61sM7BuI/CxbRi78CMAwC8u/ik2lYXx6/FZ/NG+XmDsmmPpJaYAXQd++Rb27XNiVeXl5eju7kZ5eTkWy7lju9HVP+47z44EIlYTyZr3p5pT2HlhFD3X7jqd2E3etDZuFmVyxc9y3WOvOBDR0rA4dxI2qm9vO2tt3Ix4wnLE98IoOs/fzLiGXHFglUVL7berfxytjZuFpUnLvINn664q37rzSy54kxvR0rAYOOX9Hj17A68e2p5htdF28YQl2qQscuQ2d/QOC8EnS22pA9BiKVhhQ0Bj9MabKA7gxc9l9RMPcklolIaPxUb7IlO/vtIUVpt808l8D3r6QEVbUzV6Bu+IRAQ1Cmo87c11ohMJK27sGvD+T/13eP2H4s9NZY6QfKJ6g7Ng6g5wbxi4/X+izKUxt+ymTbh58yYaGxuxFPysbpnF1JGII7r3S7ZeK56/JNqK6phe5PhQfC4pzomsQLJeYjURkRTyWipR00B7cx26+sfR0TssYnuEKpaWC1lwO3qHRRuUr51cakgWvTeR4BfzbWuqxsDYNFoaKoTb6TUkYjURYQHK/Y3qiBJY8ISLvMeSBw/Z9V9NClrY1gp5JPaOeF6LbWQigfpKM+PmyIkMefuK5y8tKs528uBWIZpR00DnhdGMzu+XGRV88nPAN/q8u3zIyy2513m29ca3lot3gKGGL7vZ8qCyHCjGRqIflC2Eew7eGBsRq4lkuKrxhJUVKCe6+sdFRrR9/xbEaiLKWB8UT6p4kwckQnDPTW4bUdNAtDTsG6Lxs4Kp7r1TZmRI2OU+EE9YGdOcKHkhE5Q8WA0X3Y+CFjZ5lIbU4bzBUPlm+o1OrbuqApMAsvsiN3IZytpFS8MZc3VI6CjtTsLk5yoQsZqIyNbJI7sslu37t6Crfzxj6gi5I3Ab2EoIwVrQ5zPtBj5z+oKQRYJcHDmrKtfjYsjVjuDus+faXSdg797zXOENuc3FaiJ5JU+IXFaM12LzbpMhwrVlvrFi5OgTdDyVNdniJlII8iSI1l1VWfcxKHnQNzSpzICvBAUrbBSM90sPkytGyBUbn0tmNShVJcruC3WgXKOYdzmN3tR4OnqHxUjvJZ8H+0mw5AZErpCcUeo8fzNgL4XFSlhsfh1Q7qx+oYh8yCW6cDttR+8weq7dFefp1y7ic0nRTumeBbU5cnlzTUeh7KTfNoTXjaeMsR9BcUvkmIzsPR5B5xvkiQQlD7CESelLoWCFzS/NnIuVDEjmauTyKDMwNi3McbqJ8na5YkeqmNKhM9d9g+3yHD48ZtYaPCO2DI3syKOxU0f3dhJ5+VLIFWOD5PpTDKq+0vSdrtDauBltTdU42vOeKBstDeccHClul6tMPGGJ49J6yrwSXgtsYGw6Z/tSTZz1m6LidcuJWE0E75zYi0++mB3P9Q5g5MrG55IiXqzqAytFfsrxCKAbMeDz+AY8KWcKgi6XfGNLsZpIzhG5I+ChdNkcHxibxsCtKRGPgTtPKmg7ovP8TURLwzh7eAd6rt3Ncg8WTf9rwNigM2F3z18AyK8e8sUvMI08hF7m3LHdiCesrKcL6itNvNq6TdT5YttBUIwNrpVN9Z8rnOFtC3F3ErcKCr57g/O0rG9oUkzvoLZBVm7n+ZtobdyM1l1VwvUly2yxbrk3GaMilyFBiRMSNEqwyb/XioIWthZ3KsTAXFI0WFpOolbvzmdaCVQ3N1ZbJkZsv+koyKOzeuOGQbE/UMc9tD1jWZf7PCKNkPXuBM0l8/Zr7h/vAr/8ES7+XQP27dun2EhN1POMJuHnisrb+BFPWDjwypWMOo+ahhPLlNwwVdjBy8hEQsTRfK1K6X6qrEqivtIUQnz07I2MwQtS2IKEKCiBQAkBEjphBeVIZAQJ+7lju33jbSsJiWrcNTY6L4yidVeVE1vL0wNbCdbuSItENtPjPsJG7k2b9FD6UlFlzvxQCVIuU34x0IRPv5nfsoW2VDeMKIuE0fnN3Wj/1lVMTSdx6tSpFRE2v8egZPzcaa/1AknUKNZIz+q+emg7Os/fFNZMvSdrnIvOC6Pi2LnmsdE6WQQ6L4xmDG65oBhZ54VRZ67X+Zs4d3xPVjsNclfpnpOQyRac9+ULdP2qdwF6aW+uQ1tTNSqev4T6ShPvP//HAIBPvvhTjEwkMPniM3mLESW5ZKGl86HrFIPPIi3KpZDfWT8C5AqSR02qnHo3EwnPKFXvmYrhXf+ooeuSr8O7vsXNRMnryJ1rcSdpymKmelNFEGWRMN58vRk7t5fjE9Ub8KW/+R/84Ac/UG2mhMIDfnUfZLHBM30GboxxxJ0feO74HvFMJlmENICoEjNE1DSyLD+aCE0iJz84TpnuzgujOHr2BuqlFzIE0d5chxE3KdLVPy4G4aCwgUg+uO5n664qxGrLcPTsDcA9LypD50eJpL6hSXz6pcs4d3yPryD1XLubcd006JB4kkCS2yjm7QU8b0t1L++LIMuVvAsKI+QrlsvBANIAAA22+w+A+FuDbQPL+ALfkqEKiruvnyG8lgpltahR1/vMRVMRZFm9c2KvmOXfJs2gDoqlBSG7KfG5ZFbHpqcZZPrcx7bgno/sgoxIj78sln//7ufxiZoN2LndebLgT556aIkcOXIEN286HWbLli04derUop5A6PB5A4SXoASIHO9sa6oWwuPtFHSMloYKpSVF0OBAoQyqy76hSRFioPqO1UTEzHuKjR46cx3vnNibVwd9tXWbGGzzmQJC3kmsJgL7pf3QTpwXcWS49zvqvmT0wOmrQtzkCeYHXrni++p6b3172z1dM9zj0Pp8PBrql/SAPNUvJVQIlaezUqjvzCOCKsDbEORYSHwu+XD+mfRamlwsJcCeK1GwlH3JRD1PLFCj6+gdFo1yZCKR4TbBbXzyiLyc7OjBA7kb2ZkzZ8Tfly5dwuDg4KJeYZSPRbMY5P217qoSsUUaxOjBeILcQT/3zM+qhzQokgVHE2Oprs8e3oGjPe+hvbnOt63J5yVDx5KvIWoaWecMaeAjyIWrrzTFZFga/N45sVcM7O3SK7O84kHnJRNTvBBVxq8O/RJtNC2mXgoJyNfsF2ZYLTRdh22nHatM04B0GkjbNux0CpqmO3bbIi22xn/52bLfnR81DbQ1VQsTWY6x5Sqv8t3lNyPkAwV36z1B2uXEz+rdKQOyed/neb0SuTC5sqRkOS4qEOw+eTD1q78MLFb2B//h/O+6qNdvxHG83XEhXn75Zdy/fx9wrbjlvP2DYVYKvw8mr4qwnfrfW/jGG0OqYsxakqew1ez5HgCIuBsA/NXxn+CHfdmW4eHDh9Hd3Z21nGHWEt8vwWdqlgbb/ct2/1EMbjEc+cyTqIuuVxVjCpA3X2/OEDUAGX/v2FaOr3zZcaHOnDmDixcv+u6HYR4lq/LB5HLTwBtf24lN6ws2hMfkYOf28gwhk9mxrRxvvt6M051PYcc2pwwLG1OI6LCBIE9TW4LFBgCN1RFc/Ps9bLkVAV8/8of4ype34M3Xm8Vrj4ISDwzzqFkVi41orI5g8B+ewsvPNmDXxzeqijMFyqayME53PiVEjWEKHUPXNKRsG47d9tB2S8OGhjRCSC1rVki5aeC5p2vx3NO1qqLMKqK9rCrBMMWD0mKz00tzRRmGYR4V+kM7zbXWNIjMKABooUXO9WAYhnnEKC22B/PzqiIMwzAFhZFhnkkxNlpcsr7Euw3DMExBk0dWgF3RQub+/fvo7u4WjzoxDJMhbP4CNj87jfUb1u7Nl0z+XL3Sjy98oQW/m5pTFQXc5z8Z5qOA0mJbv4HnnxUqz/75QSFqxw83oFwxz+xLB2oC1zNMsWBYmoa0bbtPGGiAnYYGIAQdGjQApap9MI+IX485bzp5pXMv/vrLv68qvqL0nr8HACvypl2GWWmUWVGmsPn83t9bc1H78c/u4vov72LTpk0sbExBwsL2mPOTy/fQ/q2lvRtuKbz+vQ/wla+/DQB47rnnVMUZ5pGg6bpup9NpaJoGTdOQTqdh2zbkZUxhsu/pz+LSj3+mKrYq8LvYmELB931sqo2YwuWN//pvHD58WFVsRXnmmWfw/e9/n0WNKWjYYmMY5rGGLTaGYT4SsLAxDFN06OvWrQMA4X4S09PT7IYyDPNYYJombNt5wr2kpAQaADsUCsE0TczMzMAwDCSTSSSTSQCAYRgscAzDFCyyPkUizndMdQBIpVJIJJyvrVdWVuKDDz6ApmkIh8NCBRmGYQqRJ598EuvXO99WWVhYcLzNjRs32olEAqlUCoZhwLIsVFVVYWZmBpZl4cGDB6r9Mgzz2KIKsysMGy0/wycUDkHXNSSTVsYXPdeZjkeYSqVhWSnoOhyDCkAymURa+r65HnI8yLSdhvXA2ckTFU/gww8/FGVKSkqcDybLZ15RUYHZ2VksLCyAYZiPAiFVgWDyFDZC03VnOoYegqZrePBg3vlKO60P6bBT7m9NA2wbpRs2QNM1zE7PAACMkjDCRhjzC/OwrTQMw8CmTZswPT0Ny7Joqppml5aWYnZ2Vuw8HA4jGo3Ctm3cu3cv++wYhikSgoVNFV23FcJmlm5A0krCyun5pREKhxEOOy8aciJfNlKpFCzLgqZpD4XOBw2aCJeFw2GEQiHMz887FlskEkEqlcLCwkKGS8owTHGjqd9cFoitlD4Auo5QKOSIlDv7wk6nHRXTUggZBjRNh5WUxU+DURKGBiD5IOk4lq4FBwBGuATRaBSJ2WnMzDiWnKZp0HUdqVQq0xUNh8Ni5fz8PEzTxDx/84BhihYNwe/wUyUP83VEdcOATYIGx810BC0Fi2ZghMMoWbfOMbCSyQwhE2g6dF1DOpVyftvO/tavX49UKoVkMomSkhL8P2HPj2V0t0w1AAAAAElFTkSuQmCC"
                    await this.render_captcha()
                    // await this.get_notification()
                    await this.form_validation()
                }
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    case 404:
                        this.$router.push("page_404")
                        break
                    default:

                }
            } finally {

            }
        },
        render_captcha() {
            return axios.get(this.captcha_url,  {headers: { Hostname: window.location.hostname }})
                .then(response => {
                    if (response.data.status == 'success') {
                        this.captcha_image_base64 = response.data.captcha.base64_encoded_image
                        this.encrypted_answer = response.data.captcha.answer
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        return Promise.reject(error.response.status)
                        // this.$noty.error('登入失敗: ' + error.response.status + error.response.data)
                    }
                })
        },
        submit() {
            this.is_logging = true
            var params = {
                "username": this.username,
                "password": this.password,
                "role": "staff",
                "user_answer": this.captcha_user_answer,
                "encrypted_answer": this.encrypted_answer,
            }

            axios.post(this.login_url, params,  {headers: { Hostname: window.location.hostname }})
            .then(response => {
                if (response.data.status == 'success') {
                    this.need_captcha = false
                    localStorage.setItem("need_captcha", false)
                    localStorage.setItem("authentication_token", response.data.token)
                    localStorage.setItem("staff_expired_at", this.$moment.utc(this.$moment().add(this.$store.state.global_setting.login_expiration_period, 'second')).format())
                    this.$parent.init()
                } else {
                    this.is_logging = false
                    this.need_captcha = true
                    localStorage.setItem("need_captcha", true)
                    this.render_captcha()
                    var msg_i18n = {
                        // "incorrect username or password": "帳號或密碼錯誤",
                        // "captcha verification failed": "錯誤的驗證碼",
                        // "captcha verification timeout": "驗證碼逾時失效",
                        "incorrect username or password": this.$t('ui.pages.login.errors.account_or_password_incorrect'),
                        "captcha verification failed": this.$t('ui.pages.login.errors.verification_code_incorrect'),
                        "captcha verification timeout": this.$t('ui.pages.login.errors.verification_code_expired'),
                    }
                    _.forEach(response.data.errors, error => {
                        _.forEach(error, message => {
                            console.log(message)
                            // this.$noty.error('登入失敗: ' + msg_i18n[message])
                            this.$noty.error(
                                this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                msg_i18n[message]
                            )
                        })
                    })
                }
            })
            .catch(error => {
                this.is_logging = false
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    var msg_i18n = {
                        // "Unknown Host": "您所在的網站尚未註冊本系統",
                        "Unknown Host": this.$t('ui.pages.login.errors.your_site_has_not_registered_system'),
                    }
                    // this.$noty.error('登入失敗: ' + error.response.status + msg_i18n[error.response.data.errors])
                    this.$noty.error(
                        this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                        error.response.status +
                        msg_i18n[error.response.data.errors]
                    )
                }
            })
        },
        get_notification() {
            return axios.get(this.$store.state.routes.get_notification_shutdown_url)
                .then(response => {
                    if (response.data.status == 'success') {
                        this.notification = response.data.notification
                        this.notification.urgent = false
                        if (
                            this.$moment(
                                this.notification.estimated_shutdown
                            ).isBefore(
                                this.$moment().add(7, 'day')
                            )
                        ) {
                            this.notification.urgent = true
                        }
                    }
                })
                .catch(error => {
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+': '+
                        this.$t('ui.general.server_offline')+', '+
                        '無法取得notification')
                })

        },
        focus_input(ref_name) {
            if (this.$refs[ref_name]) {
                this.$refs[ref_name].focus()
            } else {
                if (this.is_development) {
                    this.submit()
                }
            }
        },
        auto_input() {
            this.username = "admin@by-express.com"
            this.username = "admin@neuron.com"
            this.password = "12345678"
            this.captcha_user_answer = "TEST"
        },
        change_i18n(language = "zh-TW") {
            localStorage.setItem("language", language)
            this.$store.state.language = language
        },
        form_validation() {
            $('.ui.form').form({
                on: 'blur',
                fields: {
                    username: {
                        identifier: 'username',
                        rules: [{
                            type: 'empty',
                        }]
                    },
                    password: {
                        identifier: 'password',
                        rules: [{
                            type: 'empty',
                        }]
                    }
                }
            })
        }
    },
    components: {
        NotificationBox,
        ErrorBox,
    },
}
</script>

<style scoped lang="scss">
    .ui.container {
        padding-top: 60px;
    }
    img.captcha {
        cursor: pointer;
    }
    @media only screen and (max-width: 767px) {
        .ui.container {
            padding-top: 18px;
        }
        img.captcha {
            max-width: 310px;
            width: 100%;
        }
        h3.noty {
            margin: 0;
        }
    }
</style>
